/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const sidePaneMessages = defineMessages({
    dashboard: {
        id: 'luis.luisAppSidebar.dashboard',
        defaultMessage: 'Dashboard'
    },
    build: {
        id: 'luis.luisAppSidebar.build',
        defaultMessage: 'Build'
    },
    manage: {
        id: 'luis.luisAppSidebar.manage',
        defaultMessage: 'Manage'
    },
    appAssets: {
        id: 'luis.luisAppSidebar.appAssets',
        defaultMessage: 'App Assets'
    },
    intents: {
        id: 'luis.luisAppSidebar.intents',
        defaultMessage: 'Intents'
    },
    entities: {
        id: 'luis.luisAppSidebar.entities',
        defaultMessage: 'Entities'
    },
    improveAppPerformance: {
        id: 'luis.luisAppSidebar.improveAppPerformance',
        defaultMessage: 'Improve app performance'
    },
    reviewEndpointUtterances: {
        id: 'luis.luisAppSidebar.reviewEndpointUtterances',
        defaultMessage: 'Review endpoint utterances'
    },
    phraseListFeature: {
        id: 'luis.luisAppSidebar.phraseListFeature',
        defaultMessage: 'Features'
    },
    patterns: {
        id: 'luis.luisAppSidebar.patterns',
        defaultMessage: 'Patterns'
    },
    prebuiltDomains: {
        id: 'luis.luisAppSidebar.prebuiltDomains',
        defaultMessage: 'Prebuilt Domains'
    },
    settings: {
        id: 'luis.luisAppSidebar.settings',
        defaultMessage: 'Settings'
    },
    applicationInformation: {
        id: 'luis.luisAppSidebar.applicationInformation',
        defaultMessage: 'Application Information'
    },
    azureResources: {
        id: 'luis.luisAppSidebar.azureResources',
        defaultMessage: 'Azure Resources'
    },
    publishSettings: {
        id: 'luis.luisAppSidebar.publishSettings',
        defaultMessage: 'Publish Settings'
    },
    versions: {
        id: 'luis.luisAppSidebar.versions',
        defaultMessage: 'Versions'
    },
    collaborators: {
        id: 'luis.luisAppSidebar.collaborators',
        defaultMessage: 'Collaborators'
    }
});
